import {Component, Input} from '@angular/core';
import {StatusEventGroupPageDisplayDetails} from '@models/pages/status-event-group-page/status-event-group-page-display-details';
import {StatusEventPageEventDisplayDetails} from '@models/pages/status-event-page/status-event-page-event-display-details';
import {StatusEventGroupPageDataService} from '@services/pages/status-event-group-page/data/status-event-group-page-data.service';
import {MenuItem} from '@models/sidebar/menu-item';
import {MenuNotificationService} from '@services/menu-notification/menu-notification.service';
import {LeftMenuService} from '@services/left-menu/left-menu.service';
import {switchMap} from 'rxjs/operators';
import {FilterEvent} from '@models/pages/status-event-group-page/header-filter-event';

@Component({
    selector: 'scitis-status-event-group-row',
    templateUrl: './status-event-group-row.component.html',
    styleUrls: ['./status-event-group-row.component.scss'],
    standalone: false
})
export class StatusEventGroupRowComponent {

  @Input()
  public menuItemParent: MenuItem = new MenuItem();

  @Input()
  public filtering: FilterEvent = new FilterEvent();

  @Input()
  public downloadingAmount: number = 5;// should be obtained before eventDetails

  @Input()
  set eventDetails(value: StatusEventGroupPageDisplayDetails) {
    this._eventDetails = value;
    this.allStatusEventPageData = this.statusEventGroupPageDataService
      .parseStatusEventResponseToDisplayDetails(value.statusEventPageData);
    this.statusEventPageData = this.allStatusEventPageData.slice(0, this.downloadingAmount);
  }

  public _eventDetails: StatusEventGroupPageDisplayDetails | undefined;
  public isCollapsed: boolean = true;
  public allStatusEventPageData: StatusEventPageEventDisplayDetails[] = [];
  public statusEventPageData: StatusEventPageEventDisplayDetails[] = [];

  public get isLoading(): boolean {
    return this.statusEventPageData.length !== this.allStatusEventPageData.length;
  };

  constructor(
    private statusEventGroupPageDataService: StatusEventGroupPageDataService,
    private menuNotificationService: MenuNotificationService,
    private leftMenuService: LeftMenuService,
  ) {
  }

  public onLoadMoreEvents(): void {
    this.statusEventPageData = this.allStatusEventPageData.slice(0, this.statusEventPageData.length + this.downloadingAmount);
  }

  public redirectToStatusPage($event: string): void {
    let statusPageMenuItem = new MenuItem();
    const statusPageId = this._eventDetails?.statusEventPageData.find(item => $event === item.signalName)?.statusEventPageId;
    this.leftMenuService.getMenuItems(String(this._eventDetails?.machineId), false)
      .pipe(switchMap(items => {
        statusPageMenuItem = items.find(({pageId}) => +pageId === statusPageId);
        return this.leftMenuService.getParent(String(String(this.menuItemParent.machineGroupId) + '_' + statusPageMenuItem.parentId), true);
      }))
      .subscribe(machineMenuItem => {
        machineMenuItem.menuItemParent = this.menuItemParent;
        statusPageMenuItem.menuItemParent = machineMenuItem;
        this.menuNotificationService.broadcastClickOnDashboard(statusPageMenuItem);
    });
  }
}
